export default "__VITE_ASSET__3a441704__"